import { Route } from "react-router-dom";
import RevenueByNetworkScreen from "../../../container/Reservations/RevenueByNetworkScreen";
import { APP_URLS } from "../../../utils/constant";

const RevenueByNetworkRoutes = (access = {}) => {
  const { view } = access;

  return (
    <>
      {!!view && (
        <Route
          path={APP_URLS.REVENUE_BY_NETWORK.HOME}
          element={<RevenueByNetworkScreen />}
        />
      )}
    </>
  );
};

export default RevenueByNetworkRoutes;
